<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import OrdersList from "@/components/orderslist"
import Promotions from "@/components/promotion"; 
import InvoicesStatus from "@/components/invoicesStatus";
import Highlights from "@/components/highlights";

import BannerApi from "@/services/banner-api";
import ItemsApi from "@/services/items-api";
import UsersApi from "@/services/users-api";

import {Dimensions} from "../banner-news/bannerDimensions";


export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,OrdersList,Promotions ,InvoicesStatus,Highlights
  },

  mounted(){
    
    if(sessionStorage.getItem("userr")==0 && sessionStorage.getItem("agreeToPrivacyPolicy")==0){
        this.getPrivacyPolicy()
    }
    this.findBanner();
    this.getAllBrands()
  },

  data(){
    return {
      selectedBrand: null,
      isBannerTableBusy:false,
      bannerList: [],
      filter:null,
      brandsList:[],
      isgettingBrands:false,
      privacyPolicyModal:false,

      dimensions : Dimensions,

    }
  },
  
  methods: {
    findBanner() {
      this.isBannerTableBusy = true;
      BannerApi.getBanners()
        .then((result) => {
          this.bannerList = result;
        })
        .finally(() => {
          this.isBannerTableBusy = false;
        });
    },

    getAllBrands(){
      ItemsApi.getAllBrands().then(
          result => {
            if(result && result.length){
              this.brandsList=result;
            }
            for(var i in this.brandsList){
              if(this.brandsList[i].name.toLowerCase().trim()== "siaam"){
                this.brandsList[i].isSiaam =true
                //this.selectedBrand=this.brandsList[i]
              }
              if(this.brandsList[i].name.toLowerCase().trim()== "record"){
                this.brandsList[i].isRecord =true
              }
            }
          }
      ).then(
        ()=>{
          this.isgettingBrands=true
        }
      )
    },

    findItems(){
      if(this.filter == null 
      ){
        return ;
      }
      this.$router.push({ name:'Addneworder' ,path: '/orders/newOrder', query: {brand: this.selectedBrand, filter:this.filter, isHomePageRequest:true}})
    },

    accept(){
        UsersApi.acceptTerms().then(
          (result)=>{
              if(result){
                  this.privacyPolicyModal=false
              }
          }
      )

    },

    getPrivacyPolicy(){
      UsersApi.getPrivacyPolicy().then(
        (result)=>{
          if(result != 1){
            this.privacyPolicyModal=true
          }
        }
      )
    }


  },

};
</script>

<style >

.blockTitle {
    margin: 0 0 30px;
}

.pageHeader h1, .blockTitle {
    border-bottom: 1px solid #ffc220;
    color: #2a2c74;
    
    font-weight: normal;
    font-size: 29px;
    margin: 0;
    padding: 0 0 10px;
    position: relative;
    
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  height: 100px;
  width: 100px;
  background-size: 100%, 100%;
  border-radius: 50%;
  background-image: none;
}

.carousel-control-next-icon:after
{
  content: '>';
  font-size: 55px;
  color: rgb(254, 194, 53);
}

.carousel-control-prev-icon:after {
  content: '<';
  font-size: 55px;
  color: rgb(254, 194, 53);
}

.modal-dialog.modal-xl {
    min-width: 95% !important;
}

</style>
<template>
  <Layout>

    

    <!-- ADS Banner SECTION -->
    <div class="row ">
      <div class="col-12 d-none d-sm-block">
          <b-carousel
                style="text-shadow: 0px 0px 2px #000"
                :img-width="dimensions[0]['width']"
                :img-height="dimensions[0]['height']"
                :interval="4000"
                indicators
                controls
              >
                <b-carousel-slide :caption="$t('customerHomePage.banners.caption')"  img-blank img-alt="Blank Image " v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <p class="text-primary">
                    {{$t('customerHomePage.banners.empty')}}
                  </p>
                </b-carousel-slide> 

                <div v-for="banner in bannerList" :key="banner.id" >
                  <b-carousel-slide v-if="!isBannerTableBusy"
                    :img-src="'/api/banner/get/' + banner.generatedName" style="height:100%;width:100%"
                  ></b-carousel-slide>
                </div>
          </b-carousel>
      </div>
    </div>

    
    <div class="row pb-2 mb-4  " style="background-color: #fec23530">
      <div class="col-2 d-none d-sm-block" />
      <div class="col-8 d-none d-sm-block" >

        <div class="row mr-2 ml-2 mt-2 mb-2 ">
          <div class="col-4 text-left">
            <router-link tag="a" :to="{ path: '/orders/newOrder'}"><span class="text-primary font-size-14  d-none d-sm-block"><i class="fas fa-car pr-sm-2 font-size-16 "></i> <u>{{$t("customerHomePage.search.vehicule")}}</u></span></router-link>
          </div>

          <div class="col-4 text-center">
           <router-link tag="a" :to="{ path: '/orders/newOrder'}"><span class="text-primary font-size-14  d-none d-sm-block"><i class="fas fa-registered pr-sm-2 font-size-16"></i> <u>{{$t("customerHomePage.search.oem")}}</u></span></router-link>
          </div>

          <div class="col-4 text-right">
            <router-link tag="a" :to="{ path: '/orders/newOrder'}"><span class="text-primary font-size-14  d-none d-sm-block"><i class="fas fa-atlas pr-sm-2 font-size-16"></i> <u>{{$t("customerHomePage.search.competitor")}}</u></span></router-link>
          </div>

        </div>
        

        <div class="row">
          <div class="col-12">

            <b-input-group  >
              <b-form-input size="lg" class="border-warning text-primary" v-model="filter" :placeholder="$t('customerHomePage.search.placeholder')" style="height:50px; font-size:20px;"  @keyup.native.enter="findItems()"
                  ></b-form-input>    
              <template v-slot:append>
                  <b-button  size="lg" variant="warning" @click="findItems()">
                  <i class="bx bx-search-alt text-primary font-weight-bold font-size-22 align-middle"></i>
                  </b-button>

              </template>      
              <template v-slot:prepend>
                <b-dropdown size="" variant="warning" class=" d-none d-sm-block">
                  <template slot="button-content">
                      <!-- <div v-for="brand in brandsList" :key="brand.id" > -->
                        <img  v-if="selectedBrand == null" height="33" src="@/assets/images/brands.png"  />
                        <img  v-if="isgettingBrands && selectedBrand != null && selectedBrand.isSiaam " height="33" src="@/assets/images/brand1.png"  />
                        <img  v-if="isgettingBrands && selectedBrand != null && selectedBrand.isRecord " height="33" src="@/assets/images/brand2.png"  />
                      <!-- </div> -->
                      
                  </template>

                    <b-dropdown-item   @click="selectedBrand = null" >
                        <strong class="text-primary font-size-16">{{$t('catalog.filters.brandFilter.all')}}</strong>
                    </b-dropdown-item>

                      <b-dropdown-item  v-for="brand in brandsList" :key="brand.id"  @click="selectedBrand = brand" >
                          <div v-if="isgettingBrands && brand.isSiaam ">
                          <img
                            v-if="isgettingBrands && brand.isSiaam "
                            src="@/assets/images/brand1.png" 
                            alt="user-image"
                            class="mr-2"
                            height="30"
                          />
                          </div>
                          <img
                            v-if="isgettingBrands && brand.isRecord "
                            src="@/assets/images/brand2.png" 
                            alt="user-image"
                            class="mr-2"
                            height="30"
                          />
                      </b-dropdown-item>
                </b-dropdown>
              </template>                      
            </b-input-group>

          </div>
        </div>
        
      </div>
      <div class="col-2 d-none d-sm-block" >
        
      </div>
    </div>

    <!-- END OF ADS Banner SECTION -->

    <div class="row p-4">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pr-lg-2 pt-sm-2 ">
              <div class="card h-100  ">
              <div class="card-body card border border-warning bg-Default p-0" >
                <InvoicesStatus />
              </div>
            </div>
      </div>

      
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-lg-2 pt-2 ">
          <div class="card h-100 "  >
              <div class="card-body card border border-warning bg-Default ">
                <Promotions />
              </div>
          </div>
        </div>
    </div>

    <div class="row ">

        <div class="col-12">
          <Highlights />
        </div>

    </div>

    <div class="row pl-4 pt-4 pr-4 pb-4" >
          <div class="card h-100 w-100">
            <div class="card-body card border border-warning bg-Default">
                <h4 class="card-title pb-2 font-size-18 text-primary"><i class="fas fa-history  mr-2" />{{$t('customerHomePage.orders.title')}} </h4>
                <OrdersList :isHomePage=true :isCurrent=true />
            </div>
          </div>
    </div>

    <b-modal
      scrollable
      title-class="text-primary"
      title-tag="h5"
      hide-header-close
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      centered
      v-model="privacyPolicyModal"
    >
      
      <div class="mt-2 mb-0">
      <h4 class="mb-3">{{$t('customerHomePage.privacyPolicy.title')}} </h4>

      

      <p class="p-3 text-justify">
        <i>
        Nous collectons des informations dans le but d'améliorer nos services et votre expérience lors de l'utilisation de cette application. Cela nous aide à nous assurer que notre site fonctionne conformément à vos attentes.

        <br/><br/>We collect information to provide you better services and experience when using our application. This helps us to make sure that our website functions as you expect.
        </i> 
      </p>

      <div class="row pr-2">
        <div class="col-12 text-sm-right">
            <b-button variant="outline-danger" href="/logout" class="mr-2 mb-2 mb-md-0" size="md">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
            <span>{{ $t('customerHomePage.privacyPolicy.logOut') }}</span> </b-button>
            <b-button  variant="success" @click="accept()" class="font-weight-bold font-size-14" size="md" >{{ $t('customerHomePage.privacyPolicy.accept') }}</b-button>
        </div>
      </div>
      </div>

    </b-modal>
  
  </Layout>
</template>

